import React from 'react';


function RegistryRelationship() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-8">
        <h1 className="text-2xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Registry Relationship</h1>

        <div className="text-sm text-gray-800 leading-relaxed space-y-8">
          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Standards Definition</h2>
            <p>
              The relationship begins with the <strong>Standards</strong>. These are the technical documents, published by the Council, that define authoritative requirements. They define the criteria against which organizations are measured. They are open, transparent, and versioned.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Authority Hierarchy</h2>
            <p>
              The governance structure operates on a clear hierarchy of authority:
            </p>
            <ol className="list-decimal pl-5 mt-2 space-y-2">
              <li><strong>Standards:</strong> The Standards define the authoritative technical requirements.</li>
              <li><strong>Council:</strong> The Council determines compliance with those requirements.</li>
              <li><strong>Registry:</strong> The Registry records the official determinations made by the Council.</li>
            </ol>
            <p className="mt-2">The Registry is subordinate to the Council and functions as the official record of the Council's decisions.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">declaration Authority</h2>
            <p>
              The Council acts as the <strong>declaration Authority</strong>. We interpret the standards and apply them to specific applicants. We review evidence, conduct audits, and determine compliance. The declaration is the official determination resulting from this process.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Registry Function</h2>
            <p>
              The <strong>Registry</strong> is the "record." It is the single source of truth for the status of all declarations.
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>If a company is declared, it is listed in the Registry.</li>
              <li>If a declaration expires, the Registry is updated.</li>
              <li>If a declaration is revoked, the Registry reflects this status.</li>
            </ul>
            <p className="mt-2">
              A physical or digital certificate is merely a representation; the Registry entry is the validation.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Public Verification and Permanence</h2>
            <p>
              The Registry provides a public utility: <strong>Verification</strong>. declaration data is public and permanent. The Registry serves as the authoritative source for all declaration claims. Records are final and will not be altered except through formal enforcement or revocation procedures. Stakeholders verify claims directly against this institutional record.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#102A43] mb-3 uppercase tracking-wide">Authority and Accountability</h2>
            <p>
              This tripartite relationship—Standards (the requirements), Council (the authority), and Registry (the record)—creates a closed loop of accountability. The Council maintains the Standards and the Registry to ensure that the ecosystem remains rigorous and reliable.
            </p>
          </section>

          <div className="pt-8 border-t border-gray-200 mt-8">
            <p className="text-xs text-gray-500">
              Verify any claim by searching the <a href="/registry" className="text-[#2F80ED] hover:underline">Official Registry</a>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegistryRelationship;